import Dot from '@mui/icons-material/FiberManualRecord'
import { Tooltip } from '@mui/material'
import { CLIENTS_FLAGS } from '../../../constants'
import { UnparsedClient } from 'models/client'

interface ICFDIArticulo69BProps {
  receptor?: UnparsedClient
  addTooltip?: boolean
  returnLabel?: boolean
}

const CFDIArticulo69B = ({
  receptor,
  addTooltip = false,
  returnLabel = false,
}: ICFDIArticulo69BProps) => {
  const isFlagSet =
    (receptor && receptor.flags & CLIENTS_FLAGS.ARTICULO_69B) ===
    CLIENTS_FLAGS.ARTICULO_69B

  const label = isFlagSet ? 'Definitivo' : 'Sin coincidencia'
  const className = isFlagSet ? 'canceled' : 'active'

  return (
    <div className="status-container art-69b">
      {!returnLabel && addTooltip && (
        <Tooltip title={label}>
          <Dot className={`status-icon ${className}`} color="inherit" />
        </Tooltip>
      )}
      {!addTooltip && (
        <Dot className={`status-icon ${className}`} color="inherit" />
      )}
      {returnLabel && label}
    </div>
  )
}

export default CFDIArticulo69B
